"use strict";

define('app/header/header.controller',['rs/header/header.controller'], function (HeaderController) {
  var IRBHeaderController = HeaderController.extend({
    observes: {
      'window-keypress': 'keyWasPressed'
    },
    badges: [{
      name: 'notifications',
      icon: 'bell-o'
    }, {
      name: 'tasks',
      icon: 'check-square'
    }],
    refreshCountPropertyOnView: function refreshCountPropertyOnView(count) {
      if (!count) {
        this.getView().hideCountBadge();
      } else {
        this.getView().showCountBadge();
        this.getView().setCountBadge(count);
      }
    },
    refreshNotificationsOpenPropertyOnView: function refreshNotificationsOpenPropertyOnView(open) {
      if (open) {
        this.getView().activateNotifications();
      } else {
        this.getView().deactivateNotifications();
      }
    },
    keyWasPressed: function keyWasPressed(ev, keyCode) {
      var appController = this.getAppController(),
        notificationsController = appController.getNotificationsController(),
        tasksController = appController.getTasksController();
      if (keyCode == 27) {
        notificationsController.setOpen(false);
        tasksController.setOpen(false);
      }
    }
  });
  return IRBHeaderController;
});

